<template>
  <div class="aaaa">
    <div class="div" v-for="(son,index) in list_a" :key="index">
      <div class="question">{{son.index}}、{{son.title }}<span class="type">{{son.type == 1 ? '多选题' : '单选题' }}</span></div>
      
      <div v-if="son.type === 1" class="answerssss">
        <li v-for="(sson,index1) in son.optionList" :key="index1" >
            <input type="radio" :name="sson.code"  :value="sson.value" @change="get_radio_value(index)" v-model="checkedValue[index]" >
            <span>{{sson.code}}:{{sson.value}}</span>
        </li>
        <div style="clear: both"></div>
      </div>
      <div v-else class="answerssss">
        <li v-for="(sson,index1) in son.optionList" :key="index1">
            <input type="checkbox" :name="sson.code" :value="sson.value" @change="get_checkbox_value(son,sson,index)" v-model="checkedValue1" >
            <span>{{sson.code}}:{{sson.value}}</span>
        </li>
      </div>

      <div class="sure_daan">正确答案：A、B、C</div>
      <!-- <hr> -->
    </div>
    <button @click="btnfun" class="submit_btn">提交答案</button>
 </div>
</template>

<script>
import Cookies from "js-cookie";
import {
		answerCheck
	} from '@/api/activity.js'
export default {
  name: 'input8',
  data: function () {
    return {
      all_list: [],
      checkedValue: [], // 绑定单选框的值
      checkedValue1: [] ,// 绑定复选框的值
      showQuestionIndex: 0, //当前展示题号
      questionList:[]
    }
  },
  props: ['list_a','activityid'],
  mounted() {
        console.log(this.list_a)
    },
  methods: {
    btnfun: function () {
      // 获取input框的值
      console.log(this.all_list)
      // 如果答案长度不匹配list_a
      // this.all_list = this.all_list.null
      // console.log(this.all_list)
      for (var i = 0; i < this.all_list.length; i++) {
        if (this.all_list[i] === '' || typeof (this.all_list[i]) === 'undefined') {
          this.all_list.splice(i, 1)
        }
      }
      // 循环
      if (this.list_a.length !== this.all_list.length) {
        toast("您有未作答的题目")
        return false
      } else {
        // 传值给调用页面
        // this.$emit('transfer', this.questionList)
        let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
        if(userInfo==''){
            toast('请登录后再操作')
            return false;
        }else{
            let arr=[];
            let codeOneArr=[],codeTwoArr=[],codeThreeArr=[],codeFourArr=[],codeFiveArr=[]
            for(let i in this.list_a[0].optionList){
                if(this.list_a[0].optionList[i].active){
                    codeOneArr.push(this.list_a[0].optionList[i].code)
                }
            }
            for(let i in this.list_a[1].optionList){
                if(this.list_a[1].optionList[i].active){
                    codeTwoArr.push(this.list_a[1].optionList[i].code)
                }
            }
            for(let i in this.list_a[2].optionList){
                if(this.list_a[2].optionList[i].active){
                    codeThreeArr.push(this.list_a[2].optionList[i].code)
                }
            }
            for(let i in this.list_a[3].optionList){
                if(this.list_a[3].optionList[i].active){
                    codeFourArr.push(this.list_a[3].optionList[i].code)
                }
            }
            for(let i in this.list_a[4].optionList){
                if(this.list_a[4].optionList[i].active){
                    codeFiveArr.push(this.list_a[4].optionList[i].code)
                }
            }
            let parmsone = {
                activityId:this.activityid,
                questionId:this.list_a[0].id,
                answerCode:codeOneArr.toString(),
            }
            let parmstwo = {
                activityId:this.activityid,
                questionId:this.list_a[1].id,
                answerCode:codeTwoArr.toString(),
            }
            let parmsthree = {
                activityId:this.activityid,
                questionId:this.list_a[2].id,
                answerCode:codeThreeArr.toString(),
            }
            let parmsfour = {
                activityId:this.activityid,
                questionId:this.list_a[3].id,
                answerCode:codeFourArr.toString(),
            }
            let parmsfive = {
                activityId:this.activityid,
                questionId:this.list_a[4].id,
                answerCode:codeFiveArr.toString(),
            }
            answerCheck(this.activityid, parmsone).then((res)=>{
                if(res.code == 200){
                    arr[0].isSure=res.result.result
                    arr[0].tip=res.result.tip
                }
            })
            answerCheck(this.activityid, parmstwo).then((res)=>{
                if(res.code == 200){
                    arr[1].isSure=res.result.result
                    arr[1].tip=res.result.tip
                }
            })
            answerCheck(this.activityid, parmsthree).then((res)=>{
                if(res.code == 200){
                    arr[2].isSure=res.result.result
                    arr[2].tip=res.result.tip
                }
            })
            answerCheck(this.activityid, parmsfour).then((res)=>{
                if(res.code == 200){
                    arr[3].isSure=res.result.result
                    arr[3].tip=res.result.tip
                }
            })
            answerCheck(this.activityid, parmsfive).then((res)=>{
                if(res.code == 200){
                    arr[4].isSure=res.result.result
                    arr[4].tip=res.result.tip
                }
            })
            console.log(arr)
        }
      }
    },
    get_radio_value: function (index) {
      // 获取当前radio当前值
      console.log((index + 1) + '题' + this.checkedValue)
      this.all_list[index] = this.checkedValue[index]
    },
    get_checkbox_value: function (bigItem,smallItem,index) {
        console.log(index)
        console.log(smallItem)
        console.log(bigItem)
      // 获取当前复选框的值
        console.log((index + 1) + '题' + this.checkedValue1)
        this.all_list[index] = this.checkedValue1
        let newOpt = this.list_a;
        let checkOpt = newOpt[bigItem.index-1].optionList;
        if (bigItem.type == '0') {
            checkOpt.map((item, i) => {
                if (item.id == smallItem.id) {
                    item.active = !item.active
                } else {
                    item.active = false
                }
            })
        } else if (bigItem.type == '1') {
            checkOpt.map((item, i) => {
                if (item.id == smallItem.id) {
                    item.active = !item.active
                }
            })
        }
        
        this.list_a = newOpt;
        console.log(this.list_a)
    }
  }
}
</script>
<style scoped>
.aaaa{
    padding:0 83px;
    box-sizing: border-box;
}
li{
  list-style: none;
}
.div{
  margin: 6px 0px;
  padding-bottom: 50px;
  box-sizing: border-box;
}
.question {
  /* width:300px; */
  text-align: left;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 29px;
}
.type{
  /* width:200px;
  text-align: left; */
  width: 63px;
    height: 20px;
    background: linear-gradient(-90deg, #F9CD15, #FE7E7B);
    border-radius: 10px;
    display: inline-block;
    line-height: 20px;
    text-align: center;
    font-size: 12px;
    color: #FFFFFF;
    margin-left: 22px;
}
.answerssss li{
  width:100%;
  /* height: 20px; */
    font-size: 14px;
    color: #333333;
    vertical-align: middle;
    margin-bottom: 10px;
}
.answerssss span{
  /* float: left; */
  display: inline-block;
  /* margin-bottom: 16px; */
  margin-left: 9px;
  vertical-align: middle;
}
.answerssss input{
  /* float: right; */
  vertical-align: middle;
}
.submit_btn{
    width: 250px;
    height: 44px;
    background: linear-gradient(0deg, #FDCA4F 0%, #FEE571 60%, #FDF0B1 100%);
    border-radius: 22px;
    margin:0 auto;
    border:none;
    outline: none;
    line-height: 44px;
    text-align: center;
    font-size: 16px;
    color: #7A4D13;
    display: block;
    cursor: pointer;
}
.err_daan{
    font-size: 16px;
    font-weight: 600;
    color: #FF3E50;
    line-height: 54px;
}
.sure_daan{
    font-size: 16px;
    font-weight: 600;
    color: hsl(133, 100%, 62%);
    line-height: 54px;
}
</style>